import initialState from './initial-state'
import * as ACTIONS from 'constant/actions/permissions-management'

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.PERMISSIONS_MANAGEMENT_SHOW_MODAL:
      state = {
        ...state,
        modalShowing: true,
        modalContent: action.modalContent
      }
      break
    case ACTIONS.PERMISSIONS_MANAGEMENT_HIDE_MODAL:
      state = {
        ...state,
        modalContent: undefined,
        modalShowing: false
      }
      break
    case ACTIONS.PERMISSIONS_MANAGEMENT_GET_ALL_ROLES + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          userRoles: action.payload.data.userRoles
        }
      }
  }
  return state
}
